module.exports = __webpack_public_path__ + "static/media/account.076257f5.svg";